export default __webpack_public_path__ + "static/media/retaliation.9ab79c11.png";